











































































































































import {  ImportaEstoquesUseCase } from '@/usecases';
import { Component, Prop, Ref, Vue } from 'vue-property-decorator' ;
import { VueCsvImport } from 'vue-csv-import';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { ClienteDaImportacaoCSV, Loja } from '@/models';
import { ImportaClientesUseCase } from '@/usecases/cliente/ImportaClientesUseCase';


@Component({
	components: {
		VueCsvImport,
	},
})
export default class DialogoDeCsvClientes extends Vue {
	@Ref() csvComponent!: VueCsvImport
	@Prop() loja!: Loja
	mostra = false
	tab: null | number = null
	importaClienteUseCase = new ImportaClientesUseCase()
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
	]
	importaEstoquesUseCase = new ImportaEstoquesUseCase()
	importando = false
	estadoDaSelecao = "Nenhum arquivo selecionado"  
	csv: ClienteDaImportacaoCSV[] | null = null

	camposCsv = {
		razaoSocialOuNome: 'razaoSocialOuNome',
		cnpjOuCpf: 'cnpjOuCpf',
		dataDeNascimento: 'dataDeNascimento',
		email: 'email',
		rua: 'rua',
		numero: 'numero',
		cep: 'cep',
		bairro: 'bairro',
		complemento: 'complemento',
		cidade: 'cidade',
		uf: 'uf',
		inscricaoEstadual: 'inscricaoEstadual',
		telefones: 'telefones',
		tipoDeCliente: 'tipoDeCliente',
		codigoIBGE: 'codigoIBGE',
	}
	arquivo = 'File'

	tabelaNome: string | null = null
	tabelaId: string | null = null
	selecionado: boolean | null = null
	inputFile: HTMLInputElement | null = null

	async mostrar(tabelaId?: string, tabelaNomeRecebido?: string){
		this.tabelaId = tabelaId ? tabelaId : null
		this.tabelaNome = tabelaNomeRecebido ? tabelaNomeRecebido : null
		this.mostra = true
	}
	cancelar() {
		this.importando = false
		this.csv = null 
		this.mostra = false
		this.csvComponent.sample =  null
		this.csvComponent.fileSelected = false
		this.csvComponent.map = {}
		if(this.inputFile!= null)
			this.inputFile.value = ''
	}

	async concluirImportacao(){
		if(!this.csv) return
		try {
			await this.importaClienteUseCase.execute(this.csv)

			AlertModule.setSuccess('Itens em processamento')
		} catch (error) {
			AlertModule.setError(error)
		} finally { 
			this.importando = false
			this.csv = null 
			this.mostra = false
			this.csvComponent.sample =  null
			this.csvComponent.fileSelected = false
			this.csvComponent.map = {}
			if(this.inputFile!= null)
				this.inputFile.value = ''
		}
	}

	clickCsv() {
		this.inputFile = document.querySelector('.form-control-file')
		if(this.inputFile != null)
			this.inputFile.click();
		
	}

}
